import httpManager from "@/app/shared/utils/httpManager";

/**
 * Actualiza nuevo Correo electronico.
 * @param {number} ticketId Identificador del ticket
 * @param {Object} body Datos del correo.
 *
 * @return {Promise<Object>} Datos del correo creado
 */
export async function createClientEmail(ticketId, body) {
  const response = await httpManager.post(`/workspace/tickets/${ticketId}/emails/`, body);
  return response?.data;
}
